var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingCheckmarkGreenLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6095 0.390524C22.1302 0.911223 22.1302 1.75544 21.6095 2.27614L7.60948 16.2761C7.08878 16.7968 6.24456 16.7968 5.72386 16.2761L0.390524 10.9428C-0.130175 10.4221 -0.130175 9.57789 0.390524 9.05719C0.911223 8.53649 1.75544 8.53649 2.27614 9.05719L6.66667 13.4477L19.7239 0.390524C20.2446 -0.130175 21.0888 -0.130175 21.6095 0.390524Z",
    fill: "#1CE783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCheckmarkGreenLight1);
export default __webpack_public_path__ + "static/media/Pricing_Checkmark_green-light (1).b69611114ff5c25591b2973ac8067a54.svg";
export { ForwardRef as ReactComponent };